import { makeStyles } from '@surveycake/rc';

export const useStyles = makeStyles([
  [
    'redirectContainer',
    `
		display: flex;
		flex-direction: column;
		justify-content: center;
		align-items: center;
		margin: 30px auto;
	`
  ],
  [
    'trigger',
    `
		width: 300px;

		&:nth-of-type(2) {
			margin-top: 20px;
		}
	`
  ]
]);
